import React from 'react';
import { ArcMenuItemProps } from './types';
import { MenuItem } from '@mui/material';

const ArcMenuItem: React.FC<ArcMenuItemProps> = (props) => {
  return <MenuItem {...props} />;
};

export default ArcMenuItem;